import { render, staticRenderFns } from "./Airtime.vue?vue&type=template&id=35e5d01e&scoped=true"
import script from "./Airtime.vue?vue&type=script&lang=js"
export * from "./Airtime.vue?vue&type=script&lang=js"
import style0 from "./Airtime.vue?vue&type=style&index=0&id=35e5d01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e5d01e",
  null
  
)

export default component.exports